var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCaretRight = function SvgCaretRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1008 1008"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M349.4 132.6c6.6 0 13.2 4 17.2 7.9l346.3 346.3c4 4 7.9 11.9 7.9 17.2 0 6.6-4 13.2-7.9 17.2L366.6 867.5c-4 4-10.6 7.9-17.2 7.9-5.3 0-13.2-4-17.2-7.9l-37-37c-4-4-7.9-10.6-7.9-17.2 0-5.3 4-13.2 7.9-17.2L587.3 504 295.2 211.9c-4-4-7.9-11.9-7.9-17.2 0-6.6 4-13.2 7.9-17.2l37-37c4-3.9 11.9-7.9 17.2-7.9z"
  })));
};
export default SvgCaretRight;